import { getAccessToken } from "./supabase";
const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:8000";
export class ApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
    }
}
async function request(path, init = {}) {
    const token = await getAccessToken();
    const res = await fetch(`${API_BASE}${path}`, {
        ...init,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(init.headers || {}),
        },
    });
    if (!res.ok) {
        const text = await res.text();
        throw new ApiError(res.status, text || res.statusText);
    }
    if (res.status === 204)
        return undefined;
    return res.json();
}
export const api = {
    me: () => request("/tenants/me"),
    listEngines: (tenantId) => request(`/admin/tenants/${tenantId}/engines`),
    setEngine: (tenantId, engineId, enabled) => request(`/admin/tenants/${tenantId}/engines/${engineId}`, {
        method: "PUT",
        body: JSON.stringify({ enabled }),
    }),
    listLeads: (params = {}) => {
        const qs = new URLSearchParams();
        if (params.engine)
            qs.set("engine", params.engine);
        if (params.min_score != null)
            qs.set("min_score", String(params.min_score));
        if (params.limit != null)
            qs.set("limit", String(params.limit));
        return request(`/leads?${qs.toString()}`);
    },
};
